







































































export default {
    name: 'CustomerValuationMultiples',
    props: {
        normalizeData: {},
        singleRecordData: {},
    },
};
